import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Params } from '@angular/router';
import { UrlJsonApiObject } from '@qaroni-core/types/url-json/url-json-response';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { AddSeatsJson } from '../types/add-seats-json';
import { ConstantJson } from '../types/constant-json';
import { PaymentValidate } from '../types/payment-validate';
import { StripeSubscriptionApiObject } from '../types/subscription-response';

@Injectable({
  providedIn: 'root',
})
export class PaymentsHttpService {
  private http = inject(HttpClient);

  public addSeats$(
    companyID: number,
    subscriptionID: number,
    addSeatsJson: AddSeatsJson
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/subscriptions/${subscriptionID}`;

    return this.http.patch<StripeSubscriptionApiObject>(url, addSeatsJson, {
      observe: 'response',
    });
  }

  public removeSeats$(
    companyID: number,
    subscriptionID: number,
    addSeatsJson: AddSeatsJson
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/subscriptions/${subscriptionID}/decreases`;

    return this.http.patch<StripeSubscriptionApiObject>(url, addSeatsJson, {
      observe: 'response',
    });
  }

  public updatePaymentMethod$(companyID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/billings/portals`;

    return this.http.get<UrlJsonApiObject>(url, { observe: 'response' });
  }

  public switchConstantBilling$(
    companyID: number,
    subscriptionID: number,
    constantJson: ConstantJson
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/subscriptions/${subscriptionID}/billings/cycles`;

    return this.http.patch<StripeSubscriptionApiObject>(url, constantJson, {
      observe: 'response',
    });
  }

  public validatePaymentSuccess$(
    companyID: number,
    subscriptionID: string,
    paymentValidate: PaymentValidate
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/subscriptions/${subscriptionID}/payments/successes`;
    const params: Params = { ...paymentValidate };

    return this.http.get<StripeSubscriptionApiObject>(url, {
      observe: 'response',
      params,
    });
  }

  public validatePaymentCancel$(
    companyID: number,
    subscriptionID: string,
    paymentValidate: PaymentValidate
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/subscriptions/${subscriptionID}/payments/cancel`;
    const params: Params = { ...paymentValidate };

    return this.http.get<StripeSubscriptionApiObject>(url, {
      observe: 'response',
      params,
    });
  }

  public weWillContactYou$() {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/subscriptions/contacts`;

    return this.http.patch<StripeSubscriptionApiObject>(
      url,
      {},
      { observe: 'response' }
    );
  }
}
